import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../store/modules/user';

import useProjectsEmptyCheck from './useProjectsEmptyCheck';
import useStreamsEmptyCheck from './useStreamsEmptyCheck';

const h24 = 24 * 60 * 60 * 1000;
const m5 = 5 * 60 * 1000;

let lastTime = 0;

const useOpenGuard = () => {
  const userCreated = useSelector(userSelectors.selectUserCreated);

  const isLess24h = !!(userCreated && Date.now() - userCreated < h24);
  const hasNoDelay = () => Date.now() - lastTime > m5;
  const { hasProjects } = useProjectsEmptyCheck(isLess24h && hasNoDelay());
  const { hasStreams } = useStreamsEmptyCheck(!hasProjects && isLess24h && hasNoDelay());

  const canOpen = !hasStreams && !hasProjects && isLess24h && hasNoDelay();

  const onClose = useCallback(() => {
    if (hasNoDelay()) lastTime = Date.now();
  }, []);

  return [canOpen, onClose] as const;
};

export default useOpenGuard;
